import PropTypes from 'prop-types';

import themePropTypes from 'core/utils/prop-types/theme';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import Link from 'core/components/Link';

/**
 * Конструктор для построения контролла навигации.
 * Отдает копонент исходя из условия `active === 1` || `active === total`
 */
export default function Control({
  className,
  children,
  href,
  isOutside,
  theme: {
    outerButtons: {
      idle: {
        color: linkColor,
      },
    },
  },
}) {
  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
        .link:visited
          color ${linkColor}
      `}</style>
    </scope>
  );

  return (
    <div className={className}>
      <style jsx>{`
        .innerLink
          padding 15px 10px
          line-height 1

        .outerLink
          padding 0 20px
          text-align center
          min-width 150px

          :global(._compact) &
            padding 15px
            min-width 0
      `}</style>
      {isOutside ? children : (
        <Link
          to={href}
          type='secondary'
          className={scope.wrapClassNames('link')}
        >
          {children}
          <scope.styles />
        </Link>
      )}
    </div>
  );
}

Control.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  href: PropTypes.string,
  isOutside: PropTypes.bool.isRequired,
  theme: themePropTypes(`
    {
      outerButtons: {
        idle: {
          color,
        },
      },
    }
  `),
};
